import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout/PageLayout';
import { C, ff, t } from '../../shared/constants/dashboardConstants';
import { getAdById } from '../../api/adApi';
import { CommunityAdBadge } from '../../shared/components/AdBanner';

export default function AdDetailPage() {
  const { adId } = useParams();
  const navigate = useNavigate();
  // undefined = 불러오는 중, null = 없는 광고(지났거나 숨김 포함)
  const [ad, setAd] = useState(undefined);

  useEffect(() => {
    let alive = true;
    getAdById(adId)
      .then(found => { if (alive) setAd(found ?? null); })
      .catch(() => { if (alive) setAd(null); });
    return () => { alive = false; };
  }, [adId]);

  if (ad === undefined) {
    return (
      <PageLayout>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '80px 40px', fontFamily: ff, textAlign: 'center' }}>
          <div style={t('15px', 500, C.sub)}>광고를 불러오는 중입니다.</div>
        </div>
      </PageLayout>
    );
  }

  if (!ad) {
    return (
      <PageLayout>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '80px 40px', fontFamily: ff, textAlign: 'center' }}>
          <div style={t('20px', 700, C.bk)}>광고를 찾을 수 없습니다.</div>
          <button
            onClick={() => navigate('/community', { state: { category: 'Castar Ads' } })}
            style={{ marginTop: '24px', padding: '12px 24px', borderRadius: '12px', border: 'none', background: C.bk, cursor: 'pointer', ...t('15px', 600, C.white) }}
          >
            커뮤니티로 돌아가기
          </button>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 40px 80px', fontFamily: ff }}>
        <button
          onClick={() => navigate('/community', { state: { category: 'Castar Ads' } })}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '24px', ...t('15px', 500, C.sub) }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke={C.sub} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
          목록으로 돌아가기
        </button>

        <div style={{ background: C.white, border: `1px solid ${C.g200}`, borderRadius: '24px', padding: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <CommunityAdBadge />
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="18" cy="5" r="3" stroke={C.sub} strokeWidth="1.5" /><circle cx="6" cy="12" r="3" stroke={C.sub} strokeWidth="1.5" /><circle cx="18" cy="19" r="3" stroke={C.sub} strokeWidth="1.5" />
              <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" stroke={C.sub} strokeWidth="1.5" />
            </svg>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
            <div style={{ width: 22, height: 22, borderRadius: '50%', background: C.g200, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700, color: C.sub, flexShrink: 0 }}>c</div>
            <span style={t('14px', 500, C.sub)}>{ad.advertiser}</span>
          </div>

          <h1 style={{ ...t('22px', 700, C.bk), margin: '0 0 20px', lineHeight: 1.4, whiteSpace: 'pre-line' }}>{ad.title}</h1>

          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', paddingBottom: '20px', borderBottom: `1px solid ${C.g200}`, marginBottom: '24px' }}>
            <span style={t('13px', 400, C.sub)}>{ad.postedAt}</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px', ...t('13px', 400, C.sub) }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke={C.sub} strokeWidth="1.5" /><circle cx="12" cy="12" r="3" stroke={C.sub} strokeWidth="1.5" /></svg>
              {ad.viewCount}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px', ...t('13px', 400, C.sub) }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke={C.sub} strokeWidth="1.5" /></svg>
              {ad.likeCount}
            </span>
          </div>

          {ad.images?.map((src, i) => (
            <div key={i} style={{ width: '100%', marginBottom: '20px', borderRadius: '12px', overflow: 'hidden', background: '#1a1a1a', aspectRatio: '9/16', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {src
                ? <img src={src} alt={`${ad.title} ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <span style={t('13px', 400, C.g400)}>이미지 준비 중</span>}
            </div>
          ))}

          <p style={{ ...t('15px', 400, C.bk), margin: '0 0 28px', lineHeight: '1.8', whiteSpace: 'pre-wrap' }}>
            {ad.description}
          </p>

          <div style={{ display: 'flex', gap: '12px' }}>
            {ad.homepageUrl && (
              <a
                href={ad.homepageUrl}
                target="_blank"
                rel="noreferrer"
                style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px', borderRadius: '12px', border: 'none', cursor: 'pointer', background: C.bk, textDecoration: 'none', ...t('16px', 700, C.white) }}
              >
                홈페이지로 이동
              </a>
            )}
            {ad.instagramUrl && (
              <a
                href={ad.instagramUrl}
                target="_blank"
                rel="noreferrer"
                style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px', borderRadius: '12px', border: `1px solid ${C.g200}`, cursor: 'pointer', background: C.white, textDecoration: 'none', ...t('16px', 700, C.bk) }}
              >
                인스타그램
              </a>
            )}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
